// extracted by mini-css-extract-plugin
export var blue = "_1u-h";
export var brand = "_1u-d";
export var darkGrey = "_1u-g";
export var disabled = "_1u-6";
export var disabledSubtle = "_1u-7";
export var error = "_1u-8";
export var green = "_1u-i";
export var grey = "_1u-f";
export var icon = "_1u-0";
export var inherit = "_1u-c";
export var lightGrey = "_1u-e";
export var orange = "_1u-k";
export var pink = "_1u-m";
export var primary = "_1u-1";
export var purple = "_1u-n";
export var quaternary = "_1u-4";
export var quinary = "_1u-5";
export var red = "_1u-l";
export var secondary = "_1u-2";
export var success = "_1u-b";
export var tertiary = "_1u-3";
export var warning = "_1u-9";
export var warningSecondary = "_1u-a";
export var white = "_1u-o";
export var yellow = "_1u-j";